/*
OWC Megamenu
© 2023 OWC Studio
https://owcstudio.com/
*/
function processMenuItems(selector, isMegaMenu = false) {
  document.querySelectorAll(selector).forEach(elem => {
    if (elem.textContent.includes('|')) {
      const [title, img] = elem.textContent.split('|').map(str => str.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim());
      
      elem.innerHTML = `
        <div>
        <img
          src="${img}"
          alt=""
          loading="lazy"
          style="max-width: 100%; height: auto; margin-bottom: .4rem;">
        <div style="text-align: center">
        ${title}
      </div>
    </div>
      `;

      if (isMegaMenu) {
        elem.closest('.mega-menu__list').style.gridTemplateColumns = 'repeat(5, minmax(0, 1fr))';
      }
    }
  });
}

// Process mega menu items
processMenuItems('.mega-menu__link', true);

// Process drawer menu items
processMenuItems('.menu-drawer__menu-item');

